import { IPagination } from "../../../../types/models/pagination.models.types";
import { IUser } from "../../../../types/models/user.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  users: Array<IUser>;
  pagination: IPagination;
}

export function useGetUsersHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/users",
  });
}